// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"homePage-module_searchHeaderSection_12EAO"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/homePage.module.css
// module id = 491
// module chunks = 1 3